import React from "react";

interface IconProps {
  className?: string;
  style?: React.CSSProperties;
}

/** A table's rows, one picked out; what follows it says what the action does. */
const PickedRow = ({
  children,
  testId,
  ...props
}: IconProps & {
  children: React.ReactNode;
  testId: string;
}): React.JSX.Element => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    data-testid={testId}
    {...props}
  >
    <path d="M3 5h7M3 19h7" />
    <rect x="2.5" y="9.5" width="8" height="5" rx="1.5" />
    {children}
  </svg>
);

/** The picked row branching into the rows it links to. */
export const InvestigateRowsIcon = (props: IconProps): React.JSX.Element => (
  <PickedRow testId="InvestigateRowsIcon" {...props}>
    <rect x="15.5" y="3" width="6" height="6" rx="1.6" />
    <rect x="15.5" y="15" width="6" height="6" rx="1.6" />
    <path d="M10.5 11l5-4.5M10.5 13l5 4.5" />
  </PickedRow>
);

/** The picked row, more joining it. */
export const AddToInvestigationIcon = (props: IconProps): React.JSX.Element => (
  <PickedRow testId="AddToInvestigationIcon" {...props}>
    <path d="M18.5 9v6M15.5 12h6" />
  </PickedRow>
);

/** The picked row with its link taken away. */
export const ClearInvestigationIcon = (props: IconProps): React.JSX.Element => (
  <PickedRow testId="ClearInvestigationIcon" {...props}>
    <path d="M16 9.5l5 5M21 9.5l-5 5" />
  </PickedRow>
);
